import React from 'react';
import { Button } from '@manulife/mux';
import { useTranslation } from './translationContext';

const TableFilterSearchButton = ({ handleClick, disableSubmit }) => {
  const { t } = useTranslation();
  return (
    <Button
      id="search-applied-button"
      aria-label={t('tablefilter.defaultplaceholder.searchLabel')}
      disabled={disableSubmit}
      className="search-button search-bg-button my-auto"
      onClick={handleClick}>
      {t('tablefilter.defaultplaceholder.searchLabel')}
    </Button>
  );
};

export default TableFilterSearchButton;
